function updateHeight(){
  if ($('.module--product__text--1').length) {
    $('.module--product__text--1 .parent-span').css('height', 'calc(100% - ' + ($('.module--product__text--1').find('.module--product__text__content').height() - 25) + 'px)');
  }
}

updateHeight();

$(window).resize(function() {
  updateHeight();
});
